import { css, styled } from "@mui/material";

export const ImageWrapper1 = styled("div")(
  ({ theme }) => css`
    border: 1px solid ${theme.portfolio.header.borderColor_100};
    padding: 4px;
    border-radius: 34px;
  `,
);

export const ImageWrapper2 = styled("div")(
  ({ theme }) => css`
    border: 1px solid ${theme.portfolio.header.borderColor_200};
    padding: 4px;
    border-radius: 30px;
  `,
);

export const ImageWrapper3 = styled("div")(
  ({ theme }) => css`
    border: 1px solid ${theme.portfolio.header.borderColor_300};
    padding: 0px;
    position: relative;
    border-radius: 26px;
    overflow: hidden;

    ${theme.breakpoints.up("mobile")} {
      aspect-ratio: 288/180;
    }

    ${theme.breakpoints.up("tablet")} {
      aspect-ratio: 616/330;
    }

    ${theme.breakpoints.up("desktop")} {
      aspect-ratio: 800/424;
    }

    ${theme.breakpoints.up("desktopXl")} {
      aspect-ratio: 1016/526;
    }
  `,
);
